import { Button, Flex, HStack, Text } from "@chakra-ui/react";
import { ScheduledTransferDetail } from "../schema/scheduled-transfer.schema";
import { AppColors } from "@/styles/colors";
import { TransferTransactionTypeEnum } from "@/constants/enums";
import { RequestMovementNumber } from "@/components/common/section-components/requests/RequestMovementNumber";
import { useRoles } from "@/hooks/useRoles";
import { PermissionCode } from "@/constants/permissions";
import { Check, X } from "lucide-react";
import {
  ScheduledTransferStatus,
  TransferRequestStatus,
} from "@/constants/entity-status";

interface Props {
  request?: ScheduledTransferDetail | null;
  loadingRequest?: boolean;
  loadingRejectRequest?: boolean;
  loadingExecuteRequest?: boolean;
  setOpenRejectModal: (open: boolean) => void;
  handleExecuteRequest: () => Promise<void>;
}

export const ScheduledTransferTransactionType = ({
  request,
  loadingRejectRequest,
  loadingExecuteRequest,
  loadingRequest,
  setOpenRejectModal,
  handleExecuteRequest,
}: Props) => {

  const { userPermissions } = useRoles();

  const hasWriteAccess = Boolean(
    userPermissions?.some(
      (p) =>
        p.codigo === PermissionCode.SCHEDULED_TRANSFER &&
        p.tipoPermiso === "W",
    ),
  );

  const moreThan1 =
    request?.idMovimientoBIND ||
    hasWriteAccess;

  const cantOperateSTranfer =
    request?.estado == ScheduledTransferStatus.FINISHED ||
    request?.estado == ScheduledTransferStatus.FAILED;
  return (
    <HStack gap="4px" justifyContent={moreThan1 ? "space-between" : "flex-end"}>
      <RequestMovementNumber request={request} />
      <Flex alignItems={"center"} gap="4px">
        <Text className="account-title-label">Transacción: </Text>
        <Text
          className="account-title-label"
          color={
            request?.tipoTransaccion === TransferTransactionTypeEnum.AUTO
              ? AppColors.GREEN_ICON
              : AppColors.YELLOW_SECONDARY
          }
        >
          {request?.tipoTransaccion}
        </Text>
      </Flex>
      {hasWriteAccess &&
        !cantOperateSTranfer && (
          <HStack>
            {request?.estado != ScheduledTransferStatus.SCHEDULED && (
              <Button
                disabled={
                  loadingRequest ||
                  loadingRejectRequest ||
                  loadingExecuteRequest ||
                  request?.estado === ScheduledTransferStatus.REJECTED ||
                  request?.estado === TransferRequestStatus.FINISHED
                }
                paddingX="12px"
                paddingY="4px"
                bgColor={AppColors.LIGHT_GREEN}
                onClick={handleExecuteRequest}
                loading={loadingExecuteRequest}
                data-testid="scheduled-transfer-execute-btn"
              >
                <Check />
                <Text
                  fontWeight={600}
                  fontSize={{ base: "12px", md: "12px", "2xl": "16px" }}
                >
                  Realizar
                </Text>
              </Button>
            )}

            <Button
              disabled={
                loadingRequest ||
                loadingRejectRequest ||
                loadingExecuteRequest ||
                request?.estado === TransferRequestStatus.REJECTED ||
                request?.estado === TransferRequestStatus.FINISHED
              }
              paddingX="12px"
              paddingY="4px"
              bgColor={AppColors.RED_ICON}
              onClick={() => setOpenRejectModal(true)}
              data-testid="scheduled-transfer-reject-btn"
            >
              <X />
              <Text
                fontWeight={600}
                fontSize={{ base: "12px", md: "12px", "2xl": "16px" }}
              >
                {request?.estado === ScheduledTransferStatus.SCHEDULED
                  ? "Cancelar"
                  : "Rechazar"}
              </Text>
            </Button>
          </HStack>
        )}
    </HStack>
  );
};
